module.exports = __webpack_public_path__ + "static/media/MC3@2x.27b5e91d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/MC/MC3@2x.png
// module id = 695
// module chunks = 0